import React from 'react';
import PropTypes from 'prop-types';

export default function BoardColorOption({ color, label }) {
  return (
    <span className="board-color-option">
      <span
        style={{ backgroundColor: color }}
        className="board-designer-color-preview"
      />
      <span>{label}</span>
    </span>
  );
}

BoardColorOption.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
